export const normalizeSocialLink = (value) => {
  if (typeof value !== 'string') {
    return value || null;
  }

  const trimmed = value.trim();
  if (!trimmed) {
    return null;
  }

  if (trimmed.startsWith('@') && trimmed.length > 1) {
    return `https://www.instagram.com/${trimmed.slice(1)}`;
  }

  if (/^(?:www\.)?instagram\.com\//i.test(trimmed)) {
    return `https://${trimmed.replace(/^https?:\/\//i, '')}`;
  }

  return trimmed;
};
